import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  processPayment: ["payload"]
}, { prefix: "admin_payment" });

export { Types, Creators };
